import styled from 'styled-components';

import { HexColorDot, Multiselect } from '@dreryk/react-components';

export const StyledPatientGroupsMultiselect = styled(Multiselect)`
   width: 300px;
` as typeof Multiselect;

export const StyledColorDot = styled(HexColorDot)`
   padding: 2px;
`;

StyledColorDot.displayName = 'StyledColorDot';
